module.exports = __webpack_public_path__ + "static/CCC-25cdd6ca90de65a41f1935e624164f89.mp4";